import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {apiUrl} from '../../environments/environment';
import {
  CreateSectionRequest,
  ProjectSection,
  UpdateSectionRequest
} from '../_models/project';

@Injectable({providedIn: 'root'})
export class SectionsService {
  // Project Settings and the Project Sidebar each fetch sections independently -
  // this lets Settings announce a create/edit/archive/restore so the sidebar can
  // refetch immediately instead of showing stale data until the next navigation.
  private readonly sectionsChangedSource = new Subject<number>();
  readonly sectionsChanged$ = this.sectionsChangedSource.asObservable();

  constructor(private http: HttpClient) {}

  notifySectionsChanged(projectId: number): void {
    this.sectionsChangedSource.next(projectId);
  }

  getSections(projectId: number): Observable<ProjectSection[]> {
    return this.http.get<ProjectSection[]>(`${apiUrl}/project/${projectId}/sections`, {
      withCredentials: true
    });
  }

  createSection(projectId: number, request: CreateSectionRequest): Observable<ProjectSection> {
    return this.http.post<ProjectSection>(`${apiUrl}/project/${projectId}/sections`, request, {
      withCredentials: true
    });
  }

  updateSection(projectId: number, sectionId: number, request: UpdateSectionRequest): Observable<ProjectSection> {
    return this.http.put<ProjectSection>(`${apiUrl}/project/${projectId}/sections/${sectionId}`, request, {
      withCredentials: true
    });
  }

  archiveSection(projectId: number, sectionId: number, version: number): Observable<ProjectSection> {
    return this.http.put<ProjectSection>(`${apiUrl}/project/${projectId}/sections/${sectionId}/archive`, null, {
      params: new HttpParams().set('version', version),
      withCredentials: true
    });
  }

  restoreSection(projectId: number, sectionId: number, version: number): Observable<ProjectSection> {
    return this.http.put<ProjectSection>(`${apiUrl}/project/${projectId}/sections/${sectionId}/restore`, null, {
      params: new HttpParams().set('version', version),
      withCredentials: true
    });
  }
}
